import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export function AutocompleteSearchRequired({
  dataList,
  optionLabel,
  labelText,
  onChangeHanddle,  
  disabled,
  required = false,
  control,
  name,
  setValue
}) {
  const { t } = useTranslation();
  const {
    field: { ref, ...inputProps },
    fieldState: { error },
  } = useController({
    name,
    control,
    defaultValue: null, // Agrega un valor predeterminado aquí
    rules: {
      required: required && {
        value: true,
        message: t('login.requiredDefault'),
      },
    },
  });


  useEffect(() => {
    inputProps.onChange(null);
  }, [dataList]);


  //ERROR AL BORRAR CON LA X DE CLEAR 
  const onChangeHandleInner = (value) => {
    onChangeHanddle(value);
    inputProps.onChange(value);
  };

  return (
    <Autocomplete
      options={dataList}
      getOptionLabel={(option) =>
        option ? (typeof option === "string" ? option : optionLabel(option)) : ""
      }
      onChange={(e, value) => {
        if (value === null) {
          setValue(name, "");
        } else {
          onChangeHandleInner(value);
        }
      }}
      disabled={disabled}
      sx={{ width: { sm: "100%" } }}
      value={inputProps.value || null} // Asegurarse de que el valor nunca sea null o undefined
      isOptionEqualToValue={(option, value) =>
        option.id_comunidad === value.id_comunidad
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={labelText}
          error={!!error}
          helperText={error?.message}
          {...inputProps}
        />
      )}
    />

  );


}
